import { render, staticRenderFns } from "./player-round-info.vue?vue&type=template&id=7ed6cc9f&"
import script from "./player-round-info.ts?vue&type=script&lang=ts&"
export * from "./player-round-info.ts?vue&type=script&lang=ts&"
import style0 from "./player-round-info.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports